
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import AccountEntry from '@/extend/classes/AccountEntry';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeAccountEntry' })

export default class storeAccountEntry extends VuexModule {
  // States
  private reccords: AccountEntry[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get accountEntryLoading (): boolean {
    return this.dataLoading;
  }
  private get accountEntryRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get accountEntryLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewAccountEntry() {
    return (): AccountEntry => { 
      return this.getAccountEntry(0, true);
    }
  }

  
  public get getAccountEntry () {
    return (id: number, canCreate = false): AccountEntry => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id AccountEntry can't be 0")
        return new AccountEntry();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new AccountEntry();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            AccountEntry.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromAccountEntry(data.reccords[0] as AccountEntry);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listAccountEntry (): AccountEntry[] {
    return this.reccords;
  }

  public get listConfigAccountEntry (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mAccountEntryRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mAccountEntryClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mAccountEntryLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mAccountEntryLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(AccountEntry.fromJson(reccord as AccountEntry));
    })
    AccountEntry.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mAccountEntryConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mAccountEntryCreated (obj: AccountEntry): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareAccountEntry(obj)) {
          api.fromAccountEntry(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareAccountEntry(obj)) {
            api.fromAccountEntry(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mAccountEntryUpdated (obj: AccountEntry): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareAccountEntry(obj)) {
          api.fromAccountEntry(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mAccountEntryDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerAccountEntry (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.accountEntryRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerAccountEntry(this.accountEntryCreated, this.accountEntryUpdated, this.accountEntryDeleted);
          this.mAccountEntryRegistered();
        } else {
          setTimeout(() => resolve(this.registerAccountEntry(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.accountEntryLoading && !this.accountEntryLoaded) {
          this.mAccountEntryLoading(true);
          return AccountEntry.list(filter)
            .then((data: ListData) => {
              this.mAccountEntryLoaded(data);
              this.mAccountEntryLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredAccountEntry (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.accountEntryLoading) {
        this.mAccountEntryLoading(true);
        return AccountEntry.list(filter)
          .then((data: ListData) => {
            this.mAccountEntryLoaded(data);
            this.mAccountEntryLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createAccountEntry (obj: AccountEntry): Promise<AccountEntry> {
    return new Promise((resolve, reject) => {
      return AccountEntry.fromJson(obj).createForStoreAccountEntry()
        .then((reccords) => {
          this.mAccountEntryCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private accountEntryCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mAccountEntryConfigUpdated(config)
    const obj = objConfig.obj as AccountEntry;
    this.mAccountEntryCreated(AccountEntry.fromJson(obj));
  }

  @Action
  private accountEntryUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mAccountEntryConfigUpdated(config)
    const obj = objConfig.obj as AccountEntry;
    this.mAccountEntryUpdated(AccountEntry.fromJson(obj));
  }

  @Action
  private accountEntryDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as AccountEntry;
    this.mAccountEntryDeleted(obj.id);
  }
}
